import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ImageField } from "@/admin/ImageField";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { DataRights } from "@/components/DataRights";

const Field = ({ label, children }) => <label className="block"><span className="admin-label">{label}</span>{children}</label>;

const Credentials = () => {
  const { user, updateUser } = useAuth();
  const [c, setC] = useState({ email: user.email, current_password: "", new_password: "" });
  const save = async (e) => {
    e.preventDefault();
    try { updateUser((await api.put("/me/credentials", c)).data); setC({ ...c, current_password: "", new_password: "" }); toast.success("Sign-in details updated"); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <form onSubmit={save} className="grid gap-3 pt-5 mt-2 border-t border-[#c9a227]/40">
      <p className="eyebrow">Sign-in details</p>
      <Field label="Email (login)"><input data-testid="cred-email" className="admin-input" value={c.email} onChange={(e) => setC({ ...c, email: e.target.value })} /></Field>
      <Field label="New password (optional)"><input data-testid="cred-new-password" type="password" className="admin-input" value={c.new_password} onChange={(e) => setC({ ...c, new_password: e.target.value })} /></Field>
      <Field label="Current password (required)"><input data-testid="cred-current-password" type="password" required className="admin-input" value={c.current_password} onChange={(e) => setC({ ...c, current_password: e.target.value })} /></Field>
      <button data-testid="cred-save" className="btn-ghost-illum justify-self-start">Update sign-in details</button>
    </form>
  );
};

export const ProfileDialog = ({ open, onOpenChange, onSaved }) => {
  const { user, updateUser } = useAuth();
  const [f, setF] = useState({ name: user.name || "", bio: user.bio || "", avatar_url: user.avatar_url || "" });
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/me/profile", f); updateUser(data); toast.success("Profile saved"); onSaved?.(); onOpenChange(false); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="profile-dialog" className="bg-[#f4efe2] border-2 border-[#c9a227] rounded-none max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogTitle className="font-display text-2xl">Your reader profile</DialogTitle>
        <DialogDescription className="italic">Shown publicly next to your approved contributions.</DialogDescription>
        <form onSubmit={save} className="grid gap-4">
          <Field label="Display name"><input data-testid="profile-name" className="admin-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></Field>
          <Field label="Short bio"><textarea data-testid="profile-bio" rows={4} maxLength={1500} className="admin-input" value={f.bio} onChange={(e) => setF({ ...f, bio: e.target.value })} placeholder="A few words about you and your love of the chronicle…" /></Field>
          <div className="max-w-[12rem]"><ImageField label="Profile image" value={f.avatar_url} onChange={(v) => setF({ ...f, avatar_url: v })} aspect="aspect-square" testid="profile-avatar" /></div>
          <button data-testid="profile-save" className="btn-illum theme-flame justify-self-start">Save profile</button>
        </form>
        <Credentials />
        <DataRights />
      </DialogContent>
    </Dialog>
  );
};
